<mat-card appearance="outlined" class="mainCard">
  <mat-card-header>
    <mat-card-title>
      {{'subscription.header' | translate}} <br>
    </mat-card-title>
  </mat-card-header>
  @if (!(loadingMemberId$ | async) && !(loadingPeriods$ | async)) {
    <mat-card-content class="h-100">
      <div class="userDiv">
        {{ user?.name + ' #' + user?.permitNumber }}
      </div>
      @if (!(isSubscriptionBlocked$ |async)) {
        <div>
          @if (isExerciseStatusActive === false && !isWaitingForInsurance) {
            <div  class="information_notice">
              <p [innerHTML]="'home.exerciseStatusInactive' | translate"></p>
            </div>
          }
          @if (isActiveInscription === false) {
            <div class="information_notice">
              <p [innerHTML]="'home.inscriptionStatusNoRegister' | translate"></p>
            </div>
          }
          @if ((isExerciseStatusActive && isExemptFromInsurance)) {
            <div class="information_notice">
              <p [innerHTML]="'home.inscriptionStatusActifAndExempted' | translate"></p>
            </div>
          }
          @if ((userCanEditForm$ | async)) {
            <div class="subscriptionText">
              @if (!(inactiveMemberForSubscription$ | async)) {
                <div>
                  @if (translate.currentLang ==='fr') {
                    <div>
                      <span>
                        <p>Selon le Règlement sur l'assurance de la responsabilité professionnelle des membres de l'Ordre des dentistes du Québec,
                        le dentiste inscrit au Tableau de l'Ordre doit souscrire au Fonds à moins d'en être dispensé par l'Ordre.</p>
                        <p> Vous vous apprêtez à remplir votre formulaire de souscription annuelle en ligne. Avant de débuter,
                        veuillez vous assurer d’aviser l’Ordre des dentistes de tout changement à votre situation professionnelle.</p>
                        <p>Si un changement est requis, vous devez au préalable communiquer avec la responsable des services aux membres,
                          Carole Pigeon, par courriel à <a href="mailto:tableau@odq.qc.ca">tableau&#64;odq.qc.ca</a> ou par téléphone au 514 875-8511, poste 2263, pour lui faire part du changement à apporter.</p>
                        </span>
                      </div>
                    }
                    @if (translate.currentLang ==='en') {
                      <div>
                        <span>
                          <p>According to the regulation respecting compulsory subscription to the Professional Liability Insurance Fund of the Ordre des dentistes du Québec,
                          a dentist entered on the Roll of the Order must subscribe to the Fund unless exempted from doing so by the Order.</p>
                          <p> You are about to fill out your annual subscription form online. Before you start,
                          please make sure to notify the Ordre des dentistes of any changes to your professional situation.</p>
                          <p>If a change is required, you must first contact the Member Services Manager,
                            Carole Pigeon, by email at <a href="mailto:tableau@odq.qc.ca">tableau&#64;odq.qc.ca</a> or by phone at 514 875-8511, ext. 2263, to inform her of the change to be made.</p>
                          </span>
                        </div>
                      }
                    </div>
                  }
                  <div>
                    @if ((inactiveMemberForSubscription$ | async)) {
                      <div>
                        <span>
                          <p>Selon le règlement sur la souscription obligatoire au Fonds d'assurance-responsabilité professionnelle de l'Ordre des dentistes du Québec,
                          le dentiste inscrit au Tableau de l'Ordre doit souscrire au Fonds à moins d'en être exempté par l'Ordre.</p>
                          <p> Suivant votre changement de statut, vous vous apprêtez à remplir votre formulaire de souscription annuelle
                          en ligne afin de maintenir votre garantie excédentaire. </p>
                          <p>Avant de débuter, veuillez-vous assurer d’aviser l’Ordre des dentistes de tout changement à votre situation professionnelle.
                            Si un changement est requis, vous devez au préalable communiquer avec le responsable des services aux membres,
                            par courriel à <a href="mailto:tableau@odq.qc.ca">tableau&#64;odq.qc.ca</a> ou par téléphone au 514 875-8511, pour lui faire part du changement à apporter.</p>
                          </span>
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            }
            @if ((isSubscriptionBlocked$ |async)) {
              <div class="blockedSubscriptionMessage">
                Pour poursuivre votre souscription à l'assurance, vous devez communiquer avec le département de la souscription au
                <span class="phoneNumber">(514) 875-4823 poste 3025.</span>
              </div>
            }
          </mat-card-content>
        } @else {
          <div class="loading-spinner">
            <mat-spinner diameter="100"></mat-spinner>
          </div>
        }

      </mat-card>

      @if (!(loadingMemberId$ | async) && !(loadingPeriods$ | async) && !(isSubscriptionBlocked$ |async)) {
        <div class="periodContainer">
          @for (period of periods$ | async; track period) {
            @if (userCanEditForm || (period.isAnnual && period.hasParticularConditionsReport)) {
              <mat-card appearance="outlined"
                class="period-list-card">
                <mat-card-content>
                  @if (userCanEditForm) {
                    <div>
                      @if (period.isAnnual) {
                        <div>
                          <span class="period-card-title"> {{ period.editable ? "Formulaire pour l'année:" : "Documents pour l'année:" }} <br/> {{period.year}}</span>
                        </div>
                      }
                      @if (!period.isAnnual) {
                        <div>
                          <span class="period-card-title">Avis de souscription: <br/> {{period.description}}</span>
                        </div>
                      }
                    </div>
                  }
                  @if (!userCanEditForm && period.isAnnual && period.hasParticularConditionsReport) {
                    <div>
                      <span class="period-card-title">Documents pour l'année: <br/> {{period.year}}</span>
                    </div>
                  }
                  <div class="periodButtonsContainer">
                    @if (period.editable && userCanEditForm) {
                      <div class="buttonDiv" >
                        <button
                          mat-raised-button
                          color="primary"
                          (click)="fillForm(period)">
                          Remplir formulaire
                        </button>
                      </div>
                    }
                    @if (period.hasParticularConditionsReport) {
                      <div  class="buttonDiv">
                        <button title="Rapport de conditions particulières"
                          mat-raised-button
                          (click)="showReportParticularConditions(period)">
                          <mat-icon>summarize</mat-icon>
                          Conditions particulières
                        </button>
                      </div>
                    }
                    @if (period.receipts?.length>0) {
                      <div  class="buttonDiv">
                        <button title="Reçus"
                          mat-raised-button
                          [matMenuTriggerFor]="menu">
                          <mat-icon>receipt_long</mat-icon>
                          {{period.receipts?.length }} Reçus
                        </button>
                        <mat-menu #menu="matMenu">
                          @for (r of period.receipts; track r) {
                            <button mat-menu-item  (click)="showReceipt(r)">
                              <span>{{r.description}}</span>
                            </button>
                          }
                        </mat-menu>
                      </div>
                    }
                  </div>
                </mat-card-content>
              </mat-card>
            }
          }
        </div>
      }
      @if (loadingReport$ | async) {
        <div class="spinner-container">
          <mat-spinner diameter="100"></mat-spinner>
        </div>
      }
